"use client";

import { useEffect } from "react";
import { createLoggerClient } from "@/lib/logging/client";

const logger = createLoggerClient("pwa-component");

export function Pwa() {
  useEffect(() => {
    if ("serviceWorker" in navigator && "PushManager" in window) {
      registerServiceWorker().catch((err) => {
        logger.error(
          "Failed to register service worker",
          {
            feature: "pwa_service_worker",
            userAction: "service_worker_registration",
          },
          err,
        );
      });
    }
  }, []);

  async function registerServiceWorker() {
    await navigator.serviceWorker
      .register("/sw.js", {
        scope: "/",
        updateViaCache: "none",
      })
      .then((reg) => {
        reg.onupdatefound = () => {
          const installingWorker = reg.installing;
          if (installingWorker != null) {
            installingWorker.onstatechange = () => {
              if (
                installingWorker.state === "activated" &&
                navigator.serviceWorker.controller
              ) {
                window.location.reload();
              }
            };
          }
        };
      });
  }
  return null;
}
